module.exports = __webpack_public_path__ + "static/solution16-b91f16b8998eb830fb89a400a0a98755.png";